module.exports = __webpack_public_path__ + "static/novoLogoDynamic-8f7bee17092ff543e5188c93cce9d975.png";